module.exports = __webpack_public_path__ + "img/solicitarbeneficio.ab208b53.jpg";